import { KebabMenu, KebabMenuItem } from '@library/components/menus';
import { classNames } from '@library/utils';

export interface ProjectionKebabMenuProps {
  autoTrade: boolean;
  inGame?: boolean;
  onAutoTradeChange: () => void;
  onInGameChange?: () => void;
}

export const ProjectionKebabMenu = ({
  autoTrade,
  inGame = undefined,
  onAutoTradeChange,
  onInGameChange = () => {}
}: ProjectionKebabMenuProps) => {
  const menuItems = [
    {
      handleOnClick: onAutoTradeChange,
      message: `${autoTrade ? 'Disable' : 'Enable'} Auto Trade`,
      skipCondition: false
    },
    ...(typeof inGame !== 'undefined'
      ? [
          {
            handleOnClick: onInGameChange,
            message: `${inGame ? 'Disable' : 'Enable'} In Game`,
            skipCondition: false
          }
        ]
      : [])
  ];

  const renderMenuItems = () => {
    return menuItems.map((menuItem) => {
      const { handleOnClick, message, skipCondition } = menuItem;

      if (skipCondition) {
        return null;
      }

      return (
        <KebabMenuItem
          key={message}
          className="text-soClean-100 hover:bg-soFresh-120 flex h-8 w-full items-center rounded-md px-2 text-xs"
          handleOnClick={handleOnClick}
        >
          <span>{message}</span>
        </KebabMenuItem>
      );
    });
  };

  return (
    <KebabMenu
      className="absolute right-0 top-1"
      menuButtonClassName="z-50 h-4 w-4 group-focus-within/projection:block group-hover/projection:block"
      menuItemsClassName={classNames(
        'border border-soFresh-140 bg-soFresh-110 z-50 text-xs w-36 rounded-md',
        'group-first/projection:left-0 group-only/projection:left-0 group-last/projection:left-auto group-last/projection:right-0'
      )}
      float
      title="Projection Menu"
    >
      {renderMenuItems()}
    </KebabMenu>
  );
};
